// base64 转 bolb
import CryptoJS from 'crypto-js'

import {Base64} from 'js-base64'

export default {
    convertBase64UrlToBlob(dataUrl) {
        //去掉url的头，并转换为byte
        let bytes = window.atob(dataUrl);
        //处理异常,将ascii码小于0的转换为大于0
        let ab = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            ab[i] = bytes.charCodeAt(i);
        }
        return new Blob([ab], {type: 'audio/pcm'});
    },
    encodeText(text, encoding) {
        switch (encoding) {
            case 'utf16le' : {
                let buf = new ArrayBuffer(text.length * 4)
                let bufView = new Uint16Array(buf)
                for (let i = 0, strlen = text.length; i < strlen; i++) {
                    bufView[i] = text.charCodeAt(i)
                }
                return buf
            }
            case 'buffer2Base64': {
                let binary = ''
                let bytes = new Uint8Array(text)
                let len = bytes.byteLength
                for (let i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i])
                }
                return window.btoa(binary)
            }
            case 'base64&utf16le' : {
                return this.encodeText(this.encodeText(text, 'utf16le'), 'buffer2Base64')
            }
            default : {
                return Base64.encode(text)
            }
        }
    },
    // 播放语音
    onPlayVoice(text = '', callback) {
        try {
            let apiSecret = 'f42037a4f63bb7b61a516df816a5dd54';
            let host = location.host;
            let date = new Date().toGMTString();
            let signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`;
            let signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
            let signature = CryptoJS.enc.Base64.stringify(signatureSha)
            let key = `api_key="36964506e59946fa6e324b3dfaccfffb", algorithm="hmac-sha256", headers="host date request-line", signature="${signature}"`;
            // 建立连接
            let ws = new WebSocket(`wss://tts-api.xfyun.cn/v2/tts?authorization=${btoa(key)}&date=${new Date().toGMTString()}&host=${location.host}`);

            // 创建接收方法
            ws.onmessage = (e) => {
                let jsonData = JSON.parse(e.data);
                // 合成失败
                if (jsonData.code !== 0) {
                    speechSynthesis.speak(new SpeechSynthesisUtterance(text));
                    return
                }

                let audio = new Audio(window.URL.createObjectURL(this.convertBase64UrlToBlob(jsonData.data.audio)));

                audio.id = 'step-title';
                audio.style.display = 'none';
                document.body.appendChild(audio);

                audio.play();
                callback();
                // 监听当前的音频播放完成
                audio.addEventListener('ended', () => {
                    document.querySelector('#step-title').remove();
                    ws.close();
                });

            };
            ws.onopen = () => {
                ws.send(JSON.stringify({
                    data: {
                        status: 2,
                        text: this.encodeText(text)
                    },
                    "business": {
                        aue: 'lame',
                        auf: 'audio/L16;rate=16000',
                        tte: 'UTF8',
                        speed: 30,
                        vcn: 'xiaoyan'
                    },
                    common: {
                        app_id: '5de2105b', // APPID
                    },
                }));
            }
        } catch (e) {
            console.log(e);
            speechSynthesis.speak(new SpeechSynthesisUtterance(text));
        }
    }
}
